var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav"}},[(this.$route.name === 'Home')?_c('router-link',{attrs:{"to":"/"}},[_vm._v("Hickari Unsplash Search")]):_vm._e(),(this.$route.name !== 'Home')?_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }